import { useToast, UseToastOptions } from '@chakra-ui/react'

export const TOAST_POSITION: UseToastOptions = {
  position: 'top-right',
  isClosable: true,
}

const useCmxToast = () => useToast(TOAST_POSITION)

export default useCmxToast
